export const replacePlaceholders = (text: string, params: string[]) => {
  params.forEach((param, index) => {
    const placeholder = `{{${index + 1}}}`;
    text = text.split(placeholder).join(param);
  });
  return text;
};
